import { render, staticRenderFns } from "./CreateManualInvoicePage.vue?vue&type=template&id=5221452c&scoped=true"
import script from "./CreateManualInvoicePage.vue?vue&type=script&lang=js"
export * from "./CreateManualInvoicePage.vue?vue&type=script&lang=js"
import style0 from "./CreateManualInvoicePage.vue?vue&type=style&index=0&id=5221452c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5221452c",
  null
  
)

export default component.exports